import { mergeClassNames } from "../../utils/classes";

import type { FC, PropsWithChildren } from "react";

import * as styles from "./form.module.scss";

type FieldProps = {
	className?: string | undefined;
	testId?: string | undefined;
};

const Field: FC<PropsWithChildren<FieldProps>> = ({ children, className, testId }) => {
	return (
		<div className={mergeClassNames(styles.field, className)} data-testid={testId}>
			{children}
		</div>
	);
};

export default Field;
